import _ from 'lodash';
import React, { Component } from 'react';
import Field from './field';
import { observer } from 'mobx-react';

const isReallyEmpty = (value) => _.isUndefined(value) || _.isNull(value);

@observer
class TextArea extends Field {
	renderInput () {
		const { fieldKey, store, formStore, changeOnBlur, styles } = this.props;

		const addrs = {
			id: fieldKey,
			name: fieldKey
		};

		const { valueKey } = formStore.get(fieldKey);
		let value = store.get(fieldKey);

		if (valueKey && isReallyEmpty(value)) {

			value = store.get(valueKey);
		}

		if (changeOnBlur) {

			addrs.onBlur = this.handleChange
		} else {

			addrs.onChange = this.handleChange;
		}

		return <textarea style={styles}{ ...addrs }>{ value }</textarea>;
	}
}

export default TextArea;
